// extracted by mini-css-extract-plugin
export default {"container":"proof-rejected_container__oWxcu","greenButton":"proof-rejected_greenButton__Sq+lp"};